'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('material-ui/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M6.99 11L3 15l3.99 4v-3H14v-2H6.99v-3zM21 9l-3.99-4v3H10v2h7.01v3L21 9z' });

var SwapHoriz = function SwapHoriz(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

SwapHoriz = (0, _pure2.default)(SwapHoriz);
SwapHoriz.muiName = 'SvgIcon';

exports.default = SwapHoriz;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-icons/SwapHoriz.js
// module id = 2911
// module chunks = 0